module.exports = __webpack_public_path__ + "201811/img/top_21.496331cf.png";